import React from 'react';

export default function IntegrationsIcon() {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_1658_906)'>
        <path
          d='M12.6663 3.33337L14.6663 1.33337M1.33301 14.6667L3.33301 12.6667M4.99967 9.00004L6.66634 7.33337M6.99967 11L8.66634 9.33337M4.1997 13.5334C4.34834 13.6825 4.52497 13.8009 4.71945 13.8816C4.91394 13.9624 5.12245 14.004 5.33303 14.004C5.54361 14.004 5.75212 13.9624 5.94661 13.8816C6.14109 13.8009 6.31772 13.6825 6.46636 13.5334L7.9997 12L3.9997 8.00004L2.46636 9.53337C2.3172 9.68202 2.19885 9.85865 2.11809 10.0531C2.03734 10.2476 1.99577 10.4561 1.99577 10.6667C1.99577 10.8773 2.03734 11.0858 2.11809 11.2803C2.19885 11.4748 2.3172 11.6514 2.46636 11.8L4.1997 13.5334ZM7.99967 4.00006L11.9997 8.00006L13.533 6.46673C13.6822 6.31808 13.8005 6.14146 13.8813 5.94697C13.962 5.75249 14.0036 5.54398 14.0036 5.3334C14.0036 5.12281 13.962 4.9143 13.8813 4.71982C13.8005 4.52534 13.6822 4.34871 13.533 4.20006L11.7997 2.46673C11.651 2.31757 11.4744 2.19921 11.2799 2.11846C11.0854 2.0377 10.8769 1.99613 10.6663 1.99613C10.4558 1.99613 10.2472 2.0377 10.0528 2.11846C9.85828 2.19921 9.68165 2.31757 9.53301 2.46673L7.99967 4.00006Z'
          stroke='url(#paint0_linear_1658_906)'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_1658_906'
          x1='1.22999'
          y1='-1.40619'
          x2='10.909'
          y2='12.7809'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='white' stopOpacity='0.65' />
        </linearGradient>
        <clipPath id='clip0_1658_906'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
